var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9698 51.3691H66.8594V73.1095H69.9698V51.3691Z",
    fill: "#2B999C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0694 70.4736H63.749V74.5344H73.0694V70.4736Z",
    fill: "#197477"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8979 74.0596H43.9199V124.949H92.8979V74.0596Z",
    fill: "#2B999C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2846 77.3752V75.4528C95.2846 73.5844 93.3298 72.0508 90.9646 72.0508H45.8962C43.4986 72.0508 41.5762 73.5844 41.5762 75.4528V77.3752H95.2846Z",
    fill: "#68CECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0533 83.3047H52.7549V117.713H84.0533V83.3047Z",
    fill: "#C33025"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.617 84.7305H54.1914V116.266H82.617V84.7305Z",
    fill: "#FCCFC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7651 131.926V129.118C96.809 127.854 96.3511 126.623 95.4913 125.694C94.6315 124.766 93.4395 124.215 92.1751 124.161H44.6551C43.3898 124.215 42.1967 124.765 41.3351 125.693C40.4736 126.622 40.0133 127.853 40.0543 129.118V131.926H96.7651Z",
    fill: "#68CECE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.043 129.097V131.926H96.7646V129.118C96.7659 128.685 96.7115 128.253 96.6026 127.833H40.205C40.1029 128.247 40.0486 128.671 40.043 129.097Z",
    fill: "#197477"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2414 87.6461C58.2436 87.9221 58.1637 88.1925 58.0119 88.4231C57.8601 88.6536 57.6433 88.8338 57.3889 88.9409C57.1345 89.048 56.8541 89.0772 56.5831 89.0246C56.3122 88.9721 56.0629 88.8403 55.867 88.6459C55.6711 88.4515 55.5373 88.2032 55.4826 87.9327C55.428 87.6622 55.455 87.3815 55.5601 87.1263C55.6652 86.8711 55.8438 86.6528 56.0731 86.4993C56.3024 86.3457 56.5722 86.2637 56.8482 86.2637C57.0307 86.2623 57.2116 86.297 57.3806 86.3658C57.5495 86.4347 57.7032 86.5363 57.8327 86.6648C57.9622 86.7933 58.065 86.9462 58.1352 87.1146C58.2053 87.283 58.2414 87.4637 58.2414 87.6461Z",
    fill: "#C33025"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3528 87.6461C81.3549 87.9226 81.2747 88.1934 81.1225 88.4242C80.9702 88.6549 80.7527 88.8352 80.4977 88.942C80.2427 89.0487 79.9617 89.0772 79.6904 89.0238C79.4192 88.9704 79.17 88.8375 78.9745 88.642C78.779 88.4465 78.6461 88.1973 78.5927 87.926C78.5392 87.6548 78.5677 87.3738 78.6745 87.1188C78.7813 86.8637 78.9616 86.6463 79.1923 86.494C79.4231 86.3417 79.6939 86.2616 79.9704 86.2637C80.337 86.2637 80.6886 86.4094 80.9479 86.6686C81.2071 86.9279 81.3528 87.2795 81.3528 87.6461Z",
    fill: "#C33025"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.241 113.404C58.258 113.597 58.2347 113.791 58.1727 113.974C58.1107 114.157 58.0112 114.325 57.8807 114.468C57.7502 114.61 57.5914 114.724 57.4145 114.802C57.2376 114.88 57.0465 114.92 56.8532 114.92C56.6599 114.92 56.4687 114.88 56.2918 114.802C56.1149 114.724 55.9561 114.61 55.8256 114.468C55.6951 114.325 55.5956 114.157 55.5336 113.974C55.4716 113.791 55.4484 113.597 55.4654 113.404C55.496 113.058 55.6555 112.735 55.9123 112.499C56.1692 112.264 56.5049 112.134 56.8532 112.134C57.2015 112.134 57.5371 112.264 57.794 112.499C58.0509 112.735 58.2103 113.058 58.241 113.404Z",
    fill: "#C33025"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3528 113.404C81.3549 113.68 81.2747 113.951 81.1225 114.182C80.9702 114.413 80.7527 114.593 80.4977 114.7C80.2427 114.807 79.9617 114.835 79.6904 114.782C79.4192 114.728 79.17 114.595 78.9745 114.4C78.779 114.204 78.6461 113.955 78.5927 113.684C78.5392 113.413 78.5677 113.132 78.6745 112.877C78.7813 112.622 78.9616 112.404 79.1923 112.252C79.4231 112.1 79.6939 112.019 79.9704 112.022C80.337 112.022 80.6886 112.167 80.9479 112.426C81.2071 112.686 81.3528 113.037 81.3528 113.404Z",
    fill: "#C33025"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2859 22.9973L100.696 26.2157L84.5067 42.0485L88.3623 64.3613L68.3067 53.8637L48.2727 64.4261L52.0635 42.1025L35.8311 26.3129L58.2303 23.0297L68.2311 2.7041L78.2859 22.9973Z",
    fill: "#C46600"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2861 22.9973L68.2313 2.7041L58.2305 23.0297L68.2421 36.8645L78.3617 23.0081L78.2861 22.9973Z",
    fill: "#F9AB9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2422 36.8642L84.5178 42.1454L84.507 42.0482L100.696 26.2154L78.3294 23.0078L68.2422 36.8642Z",
    fill: "#DD6A62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3626 64.3611L84.5178 42.1455L68.2422 36.8643V53.8851L68.307 53.8635L88.3626 64.3611Z",
    fill: "#DD6A62"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2725 64.4259L68.2417 53.8851V36.8643L52.0633 42.1239L48.2725 64.4259Z",
    fill: "#DD6A62"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2418 36.8641L58.2086 23.0293L35.8311 26.3125L52.0634 42.1021V42.1237L68.2418 36.8641Z",
    fill: "#F9AB9D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2422 36.8642L78.3294 23.0078L100.696 26.2154L68.2422 36.8642Z",
    fill: "#C33025"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2422 36.8645L78.3618 23.0081L78.2862 22.9973L68.2314 2.7041L68.2422 36.8645Z",
    fill: "#DD6A62"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8311 26.3125L58.2086 23.0293L68.2418 36.8641L35.8311 26.3125Z",
    fill: "#DD6A62"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2725 64.4259L52.0633 42.1239L68.2417 36.8643L48.2725 64.4259Z",
    fill: "#C33025"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3626 64.3611L68.307 53.8635L68.2422 53.8851V36.8643L88.3626 64.3611Z",
    fill: "#F9AB9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6358 92.0957H57.1826V93.6509H79.6358V92.0957Z",
    fill: "#DD6A62"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6358 95.9189H57.1826V97.4741H79.6358V95.9189Z",
    fill: "#DD6A62"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6358 99.7422H57.1826V101.297H79.6358V99.7422Z",
    fill: "#DD6A62"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6358 103.565H57.1826V105.121H79.6358V103.565Z",
    fill: "#DD6A62"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8934 110.261V98.4895L66.6978 83.3047H54.9258L81.8934 110.261Z",
    fill: "#FFD0CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7549 84.46V89.9356L80.5325 117.702H84.0533V115.758L52.7549 84.46Z",
    fill: "#FFD0CA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.b8fffcd2d8d43e73fbf1e50ca86ec53f.svg";
export { ForwardRef as ReactComponent };